import { RootState } from "../../store";
import { createSelector } from "@reduxjs/toolkit";
import { IMaterialState } from "../../interfaces/state";

export const selectMaterial = (state: RootState): IMaterialState => state.material;
export const selectMaterialItem = createSelector([selectMaterial], (material) => material.material);
